import { fetch } from '@utils/utils';
import * as T from '@modules/hr-templates/weeks/_weeksTypes';

const getWeekTemplate = ({ addError }) => async (id: string): Promise<T.Week | {}> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/calendar/week/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Week = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export { getWeekTemplate };



// WEBPACK FOOTER //
// ./src/modules/hr-templates/weeks/_weeksActions.ts